import type {
  GetUploadsQuery,
  GetUploadsQueryVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const GET_UPLOADS: TypedDocumentNode<
  GetUploadsQuery,
  GetUploadsQueryVariables
> = gql`
  query GetUploads($limit: Int) {
    uploads(limit: $limit) {
      id
      resourceId
      filename
      createdAt
      documentId
      documentPath
      url
      isEncrypted
      draft
    }
  }
`;
